import { render, staticRenderFns } from "./MerchantForm.vue?vue&type=template&id=40eb6007&scoped=true"
import script from "./MerchantForm.vue?vue&type=script&lang=js"
export * from "./MerchantForm.vue?vue&type=script&lang=js"
import style0 from "./MerchantForm.vue?vue&type=style&index=0&id=40eb6007&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40eb6007",
  null
  
)

export default component.exports